import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WebApps from './components/WebApps';
import Advantages from './components/Advantages';
import Process from './components/Process';
import Gallery from './components/Gallery';
import Results from './components/Results';
import Clients from './components/Clients';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <WebApps />
      <Advantages />
      <Process />
      <Gallery />
      <Results />
      <Clients />
      <FAQ />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
